export default "https://cdn-static.gokick.com/assets/f56d8541e187cf36c438a68224daa166420c5eb6/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";